import { SectionsLine } from 'Components/lines/sections-line/SectionsLine';
export default SectionsLine;
